// extracted by mini-css-extract-plugin
export default {"Text":"PostedBy_Text__0G-j9","Title":"PostedBy_Title__UIAmK","User":"PostedBy_User__ZXbRm"};